/**
 * Types config livrables digitaux — alias FE typés sur le codegen OpenAPI.
 *
 * Source de vérité : `backend/app/schemas/settings.py`. Bornes (DPI choices,
 * qualité min/max, formats allowlist) viennent du BE et sont exposées dans
 * `DeliverableSettingsResponse` pour que le tab Settings construise ses
 * sliders/radios sans dupliquer les valeurs.
 */

import type { components } from './api-generated'

export type DeliverableConfigPayload = components['schemas']['DeliverableConfigPayload']
export type DeliverableConfigUpdateRequest = components['schemas']['DeliverableConfigUpdateRequest']
export type DeliverableSettingsResponse = components['schemas']['DeliverableSettingsResponse']
export type DeliverableDocResponse = components['schemas']['DeliverableDocResponse']
export type DeliverableRegenerateProgress = components['schemas']['DeliverableRegenerateProgress']
export type DeliverableRegenerateAllResponse =
  components['schemas']['DeliverableRegenerateAllResponse']
export type ShopCarouselImageResponse = components['schemas']['ShopCarouselImageResponse']

// Sub-types — Pydantic Literal sérialisés en union string côté codegen.
export type DeliverableFormat = 'jpg' | 'pdf'
export type DeliverableDpi = 150 | 250 | 300 | 600
export type DeliverableDocLang = 'fr' | 'en'
export type ShopCarouselScope = 'digital' | 'physical' | 'both'

// Helpers d'affichage UI.
export const DELIVERABLE_FORMAT_LABEL_FR: Record<DeliverableFormat, string> = {
  jpg: 'JPG (image haute fidélité)',
  pdf: 'PDF (document imprimable)',
}

export const DELIVERABLE_DPI_LABEL_FR: Record<DeliverableDpi, string> = {
  150: '150 DPI — web / proof',
  250: '250 DPI — print correct',
  300: '300 DPI — print qualité',
  600: '600 DPI — print archivage',
}

export const DELIVERABLE_DOC_LANG_LABEL_FR: Record<DeliverableDocLang, string> = {
  fr: 'Français',
  en: 'Anglais',
}

export const SHOP_CAROUSEL_SCOPE_LABEL_FR: Record<ShopCarouselScope, string> = {
  digital: 'Articles digitaux',
  physical: 'Articles physiques',
  both: 'Tous les articles',
}

export const SHOP_CAROUSEL_SCOPE_HINT_FR: Record<ShopCarouselScope, string> = {
  digital: 'Image injectée uniquement dans les listings de fichiers numériques (téléchargements).',
  physical: 'Image injectée uniquement dans les listings de prints physiques.',
  both: 'Image injectée dans tous les listings, quel que soit le type d’article.',
}
